import { Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
import BigNumber from 'bignumber.js'
import { GNANA_POOL } from 'libs/constants/src/lib/address'
import Web3 from 'web3'

import apeZoneABI from '../abi/ApeZone.json'
import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { findToken, makeBatchRequest } from '../utils'

export const getApeZonePool = async (
  walletAddress: string,
  contract: Contract,
  tokens: Token[],
  priceList: PriceList,
  web3Prop: Web3
): Promise<Stake[]> => {
  const { contractAddress, rewardAddress, routerAddress } = contract
  try {
    let abiAPEZone = apeZoneABI
    if (GNANA_POOL.includes(contractAddress)) {
      abiAPEZone = abiAPEZone.map((input) => {
        if (input.name === 'poolInfo') {
          input = {
            inputs: [],
            name: 'poolInfo',
            outputs: [
              {
                internalType: 'contract IERC20',
                name: 'lpToken',
                type: 'address'
              },
              {
                internalType: 'uint256',
                name: 'allocPoint',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastRewardBlock',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'accRewardTokenPerShare',
                type: 'uint256'
              }
            ],
            stateMutability: 'view',
            type: 'function'
          }
        }
        return input
      })
    }

    const web3 = web3Prop || new Web3(getNodeUrl(56))
    const ct = new web3.eth.Contract(abiAPEZone as any, contractAddress)

    const [userInfo, pendingReward, poolInfo] = await makeBatchRequest(web3, [
      ct.methods.userInfo(walletAddress).call,
      ct.methods.pendingReward(walletAddress).call,
      GNANA_POOL.includes(contractAddress) ? ct.methods.poolInfo().call : ct.methods.poolInfo('0').call
    ])
    const lpAddress = poolInfo['lpToken']
    const rewardInfo = findToken(tokens, rewardAddress)
    const reward = new BigNumber(pendingReward as string).dividedBy(`1e${rewardInfo?.decimals ?? 18}`).toNumber()
    const stakeAmount = userInfo['amount']
    const rewardUSD = reward * priceList[rewardAddress]?.usd || 0
    const rewardSymbol = findToken(tokens, rewardAddress)?.symbol ?? '???'

    // const balance = await balanceOf(walletAddress, lpAddress)

    const balanceInfo = await calculate(
      web3,
      {
        lpAddress,
        pool: 0,
        availableBalanceOf: '0',
        // availableBalanceOf: new BigNumber(balance).dividedBy(1e18).toString(),
        balance: stakeAmount
      },
      routerAddress,
      tokens,
      priceList
    )
    const result: Stake = {
      ...contract,
      ...balanceInfo,
      reward: +reward,
      rewardSymbol,
      rewardUSD
    }

    return [result]
  } catch (e) {
    return []
  }
}
